<script lang="ts">
    export let title: string = null;
    export let open: boolean = false;
    export let background: string = 'gray';
</script>

<div>
    <div class="header border-bottom  pr-iii py-iii pointer {background}"
         on:click={()=> open = !open}>
        <div class="box-b h-100">
            <div class="flex-100 pr-1">
                {#if title}
                    <h2>{title}</h2>
                {/if}
                <slot name="header">

                </slot>
            </div>
            <div class="arrow {open ? 'open':''}"></div>
        </div>
    </div>
    {#if open}
        <div class="content py-iii">
           <slot>

           </slot>
        </div>
    {/if}
</div>
<style>
    .header{
    height: 50px;
  }

  .header:active{
    background: var(--back-gray-300);
  }

  .arrow{
    width: 13px;
    height: 13px;
    border-right: 2px solid;
    border-bottom:2px solid;
    transform: rotate(45deg);
    position: relative;
    color: #888;
    top:-3px;
  }

  .arrow.open{
    transform: rotate(-135deg);
    top:auto;
    bottom:-3px;
  }

  .header.bg{
    border-bottom: none;
    background: var(--back-gray);
    border-radius: var(--border-radius);
  }
</style>
